<!--
 * @Description:
 * @Author: kangkang
 * @Date: 2022-07-01 16:54:59
 * @LastEditTime: 2023-04-09 17:30:34
 * @LastEditors: kangkang
 * @Reference:
-->
<template>
    <van-popup
        v-model="show"
        position="bottom"
        :style="{ height: '50%' }"
        closeable
        :close-icon="require('../assets/mask-cancel.png')"
        overlay-class="mask-daoci"
        :safe-area-inset-bottom="true"
        @close="cancelBtn"
    >
        <div class="mask-daoci-title">请选择{{ title }}</div>
        <div class="mask-daoci-content">
            <div
                class="list"
                :class="{
                    'daoci-list': title == '称谓关系',
                    'name-list': title == '悼念词',
                    'list-active': currentNum && currentNum == index
                }"
                v-for="(item,index) in data"
                :key="index"
                @click="listClick(item,index)"
            >{{ item.name }}</div>
        </div>
    </van-popup>
</template>
<script>
    export default{
        name:"mask-daoci",
        data() {
            return {
                show: true,
                currentNum: "",
            }
        },
        props: {
            title: {
                type: String
            },
            data: {
                type: Array
            }
        },
        watch: {
            title(val) {
                console.log(val)
                this.show = true;
            }
        },
        methods: {
            listClick(item,index) {
                console.log(item,index)
                this.currentNum = index + "";
                let obj = {
                    json: item,
                    show: false
                }
                this.show = false;
                this.$emit('daociConfirm',obj);
            },
            cancelBtn() {

                // this.show = false;
                this.currentNum = "";
                this.$emit('daociCancel',false);
            }
        },
        created() {

        }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
.mask-daoci {
    width: 100%;
    height: 100%;
    &-title {
        font-size: px2rem(34);
        color: #000000;
        text-align: center;
        margin-top: px2rem(50);
        margin-bottom: px2rem(42);
    }
    &-content {
        display: flex;
        align-items: center;
        flex-flow: wrap;
        font-size: px2rem(30);
        color: #828282;
        padding: 0 px2rem(30) 0 px2rem(16);
        .list {
            background: #E6E6E6;
            border-radius: px2rem(12);
            margin-bottom: px2rem(22);
            margin-left: px2rem(22);
        }
        .name-list {
            padding: px2rem(24) px2rem(40);
        }
        .daoci-list {
            width: px2rem(330);
            height: px2rem(88);
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .list-active {
            background: #A88E6E;
            color: #ffffff;
        }
    }
}
.van-popup--bottom {
    left: 50%;
}
.van-popup__close-icon {
    font-size: px2rem(30);
    top: px2rem(60);
}
</style>
